import { namespace } from 'wsm-tagging-utils';

const runGlobalDecorator = (win) => {
	namespace(win, 'DDC.tracking.shift.decorators');

	const {
		DDC: { tracking }
	} = win;

	/**
	 * The GlobalDecorator will be applied to all EventHandler implementations and
	 * anything in here should be considered "program-wide" behavior.
	 *
	 * @param {Object} window The window object
	 * @param {tracking.framework.runtime.Page} page A Page instance for page related queries
	 * @param {tracking.framework.runtime.EventHandler} delegate The EventHandler implementation to which all interface
	 *                    operations are delegated
	 * @constructor
	 */
	// tracking.shift.decorators.GlobalDecorator = function GlobalDecorator(window, page, delegate, form) {
	// 	tracking.framework.runtime.EventHandlerDecorator.call(this, window, page, delegate, form);
	// };

	// Make GlobalDecorator inherit from EventHandlerDecorator
	// DDC.classes.extend(tracking.shift.decorators.GlobalDecorator, tracking.framework.runtime.EventHandlerDecorator);

	tracking.shift.decorators.GlobalDecorator = class extends (
		tracking.framework.runtime.EventHandlerDecorator
	) {
		// constructor(window, page, delegate, form) {
		// 	super(window, page, delegate, form)
		// }
	};

	tracking.shift.decorators.GlobalDecorator.prototype.logCategory =
		// maybe we should add the word 'shift' here?
		'ws-tagging:GlobalDecorator';

	/**
	 * Replaces all spaces in the typed search content with "|"
	 *
	 * @param {Object} eventData The event data object.
	 *
	 * Relevant eventData properties:
	 * {string} trackingId The DDC racking identifier of the form
	 * {string} content The typed search content
	 */
	tracking.shift.decorators.GlobalDecorator.prototype.handleTypedSearch =
		function addTypedSearchContent(eventData) {
			const newEventData = eventData;
			newEventData.typedSearchContent =
				newEventData.typedSearchContent.replace(/([\s,|]+)/g, '|');
			this.delegate.handleTypedSearch(newEventData);
		};

	/**
	 * Consumes the form initiation event if it originates from an inventory search.
	 *
	 * @param {Object} eventData The event data object. Relevant properties:
	 * {string} trackingId The DDC tracking identifier of the form
	 */
	tracking.shift.decorators.GlobalDecorator.prototype.handleFormInitiation =
		function handleFormInitiation(eventData) {
			if (eventData.trackingId === 'INVENTORY_SEARCH') {
				this.log.info('Consuming form initiation event');
				return;
			}
			this.delegate.handleFormInitiation(eventData);
		};

	/**
	 * Consumes the click to call event
	 *
	 * needed to transform department names to one of the four accepted values: sales, service, parts or other
	 *
	 * @param {Object} eventData The event data object. Relevant properties:
	 * {string} clickToCallDepartment the department name for the dealership's phone number
	 * {string} phoneNumber the phone number clicked on to be called
	 */
	tracking.shift.decorators.GlobalDecorator.prototype.handleClickToCall =
		function handleClickToCall(eventData) {
			const { phoneNumber, element } = eventData;
			const approvedDepartmentValues = ['Sales', 'Service', 'Parts'];
			let shiftClickToCallDepartment = 'Other';

			const phoneEl = this.win.document.querySelector(
				`[data-click-to-call][data-click-to-call-phone="${phoneNumber}"]`
			);

			let department = phoneEl && phoneEl.dataset.clickToCall;

			if (department) {
				department = department.toLowerCase();

				for (let i = 0; i < approvedDepartmentValues.length; i++) {
					if (
						department.indexOf(
							approvedDepartmentValues[i].toLowerCase()
						) > -1
					) {
						shiftClickToCallDepartment =
							approvedDepartmentValues[i];
						break;
					}
				}
			}
			// }

			return this.delegate.handleClickToCall({
				clickToCallDepartment: shiftClickToCallDepartment,
				phoneNumber,
				element
			});
		};
};

export default runGlobalDecorator;
